import React from 'react';
import {
    translate,
    Filter,
    List,
    Datagrid,
    TextField,
    TextInput,
    BooleanInput,
    DateField,
    SearchInput,
    EditButton,
    ShowButton,
    SimpleShowLayout,
    Show,
} from 'react-admin';
import BoolNumField from '../controls/BoolNumField'
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import {RichTextInput} from 'ra-input-rich-text';
import HtmlToReact from 'html-to-react'
var HtmlToReactParser = HtmlToReact.Parser;
var htmlToReactParser = new HtmlToReactParser();


const editStyles = {
    root: { alignItems: 'flex-start'},
    trainer_init: {  width: '2em' },
    trainee_init: {  width: '2em' },
    booth: {  width: '2em' },
    date: {
        width: '1em',
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    date_prof: {  width: '7em' },

    inlineBlock: {
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    td_border: {
        border: "1px solid",
        width: "25%"
    }
};


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const CheckListFilter = props => (
    <Filter {...props}>
        <SearchInput source="name" alwaysOn  placeholder='Checklist Name'/>
        <TextInput source="isactive" lable="Is Active" />
    </Filter>
);

export const QuarantineFilter = props => (
    <Filter {...props}>
        <TextInput source="name" alwaysOn lable="Checklist Name" />
    </Filter>
);

const Heading=({data})=>{
    return (<h3>{data}</h3>)
}



const Contents =({data})=>{
   // console.log(data)
    var contents  = [];
    if(data){
      try{
        contents =JSON.parse(data)
      } catch(e) {
        //console.log(e)
        contents = data;
      };
    }
    console.log(contents)

    return(
      <>
      {contents && contents.map((item, index) =>(
        <tr  key={index}><td style={{fontWeight:'bold'}}>{htmlToReactParser.parse(item['procedure'])}</td>
        <td>{htmlToReactParser.parse('&nbsp;')}</td><td>{htmlToReactParser.parse('&nbsp;')}</td><td>{htmlToReactParser.parse('&nbsp;')}</td></tr>
       )
      )}
     </>
    )
}

const PhySub=({data})=>{
    console.log(data)
    return(
    (data && data.isphy_sub)?
    <>
    <tr>
        <td colSpan="4" style={{border: "1px solid"}}>
        <table style={{width:"100%"}}>
            <tbody>
                <tr>
                    <td>
                        <b>For Physician Substitue ONLY</b><br/>
                        Physical Examination performed in presence of CMD on Date:____________<br/>
                        <u>CMD Comments:</u><br/><br/>
                        Center Medical Director Signature_________________________Date_____________
                    </td>
                </tr>
            </tbody>
        </table>
        </td>
    </tr>
    <tr>
        <td colSpan="4">&nbsp;</td>
    </tr>
    </>: <></>
    )}

const PostShow = ({classes,...props}) => (
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
    >
        <SimpleShowLayout>
        <table style={{width:"99%", fontSize: "11px"}}>
            <tbody>
            <tr>
                <td colSpan="4">
                    <table  border ="1" cellSpacing="0" style={{width:"100%", textAlign: "center"}}>
                    <tbody>
                    <tr>
                        <td>
                            <table  border ="0" style={{width:"100%", textAlign: "center"}}>
                            <tbody>
                            <tr>
                                <td style={{fontSize: "9px"}}>
                                    Annual Recertification Form
                                </td>
                            </tr>
                            <tr>
                                <td ><Heading  data={props.record && props.record.name} /></td>
                            </tr>

                            </tbody>
                            </table>
                        </td>
                    </tr>
                    </tbody>
                    </table>
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td>Employee Name:</td><td colSpan="3" style={{width:"99%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
            </tr>
            <tr>
                <td>Employee Title:</td><td colSpan="3" style={{width:"99%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
            </tr>

            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td colSpan="4">
                    <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                        <tbody>
                            <tr>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"25%", textAlign: "center"}}>Procedure</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"35%", textAlign: "center"}}>Date of Reading</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Employee Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Employee Date</th>
                            </tr>
                            <Contents data={props.record && props.record.content} />

                        </tbody>
                    </table>

                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <PhySub  data={props.record} />
            <tr>
                <td  colSpan="4">{props.record && props.record.exam_desc}:&nbsp;&nbsp;Pass / Fail</td>
            </tr>
            <tr>
                <td>Exam Graded By: Signature:</td><td className={classes.td_border}>&nbsp;</td>
                <td>Date:</td><td className={classes.td_border}>&nbsp;</td>
            </tr>
            <tr>
                <td colSpan="4">
                    <table style={{width:"100%"}} cellPadding="3">
                        <tbody>
                            <tr>
                                <td>Employee Name:</td><td className={classes.td_border} style={{width:"20%"}}>&nbsp;</td>
                                <td>Signature:</td><td className={classes.td_border}  style={{width:"20%"}}>&nbsp;</td>
                                <td>Date:</td><td className={classes.td_border}  style={{width:"20%"}}>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>Management/ QA review:</td><td className={classes.td_border}>&nbsp;</td>
                                <td>Signature:</td><td className={classes.td_border}>&nbsp;</td>
                                <td>Date:</td><td className={classes.td_border}>&nbsp;</td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            </tbody>
        </table>
        </SimpleShowLayout>
    </Show>
);



export const setRecertificationList = ({classes,...props }) => (
    <List
        {...props}
        filters={<CheckListFilter  />}
        perPage={20}
        sort={{ field: 'name', order: 'ASC' }}
        bulkActionButtons ={false}
        title={'Recertificate Setup'}
        >
        <Datagrid expand={<PostShow classes={classes}/>} >
            <TextField source="name" label="Name" />
            <TextField source="roles_desc"label="Role(s)" />
            <BoolNumField  source="isactive" label="Is Active?" />
            <EditButton label='' />
            <ShowButton label='' />
        </Datagrid>
    </List>
);


export default withStyles(editStyles)(setRecertificationList)